import React from 'react';
import { ENotice, ESnapshotExists } from 'lib/types';
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import { getModelFromSnapshot } from 'lib/model';
import { UserNoticeModel } from 'lib/model/objects/userNoticeModel';
import { getFirebaseContext } from 'utils/firebase';
import { Badge } from 'lib/components/Badge';

type NoticesOverviewRowProps = {
  notice: ESnapshotExists<ENotice>;
};
export function NoticesOverviewRow(props: NoticesOverviewRowProps) {
  const { notice } = props;
  const noticeSummary =
    notice.data().referenceId ||
    notice.data().headerText ||
    notice.data().confirmedHtml;
  const noticeModel = getModelFromSnapshot(
    UserNoticeModel,
    getFirebaseContext(),
    notice
  );
  const hasInvoice = !!notice.data().invoice;
  // center this icon
  const optionClasses =
    'flex items-center justify-center gap-2 cursor-pointer rounded p-3 hover:bg-column-primary-50 hover:text-column-primary-500 focus:outline-none transition ease-in duration-100';

  return (
    <>
      <td>
        <div className="flex flex-col gap-1 my-1 items-start">
          {noticeSummary}
          {noticeModel.isDisplay() && (
            <Badge status="warning">Display Ad</Badge>
          )}
        </div>
      </td>
      <td>{notice.data().customId}</td>
      <td>
        <Badge status={noticeModel.isConfirmed ? 'success' : 'warning'}>
          {noticeModel.isConfirmed ? 'Confirmed' : 'Not Confirmed'}
        </Badge>
      </td>
      <td>
        <Badge status={hasInvoice ? 'success' : 'warning'}>
          {hasInvoice ? 'Invoiced' : 'Not Invoiced'}
        </Badge>
      </td>
      <td>
        <a
          href={`/notice/${notice.id}`}
          className={optionClasses}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ArrowUpRightIcon className="w-4 h-4" />
        </a>
      </td>
    </>
  );
}
